import React, { useEffect, useRef, useState } from 'react';

export function Notification({ message, type = 'success', isVisible, onClose, duration = 2000 }) {
    const notificationTimerRef = useRef(null);

    useEffect(() => {
        // Очищаем предыдущий таймер при изменении isVisible
        if (notificationTimerRef.current) {
            clearTimeout(notificationTimerRef.current);
        }

        // Если уведомление видимо, устанавливаем таймер на скрытие
        if (isVisible && onClose) {
            notificationTimerRef.current = setTimeout(() => {
                onClose();
            }, duration);
        }

        return () => {
            if (notificationTimerRef.current) {
                clearTimeout(notificationTimerRef.current);
            }
        };
    }, [isVisible, duration, onClose]);

    // Определяем иконку в зависимости от типа
    const getIcon = () => {
        switch (type) {
            case 'success':
                return '';
            case 'error':
                return '';
            case 'warning':
                return '';
            case 'info':
                return '';
            default:
                return '';
        }
    };

    // Определяем цвет фона в зависимости от типа
    const getBackgroundColor = () => {
        switch (type) {
            case 'success':
                return 'linear-gradient(135deg, #32d756 0%, #28a745 100%)';
            case 'error':
                return 'linear-gradient(135deg, #d73248 0%, #b02a37 100%)';
            case 'warning':
                return 'linear-gradient(135deg, #ffc107 0%, #e0a800 100%)';
            case 'info':
                return 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)';
            default:
                return 'linear-gradient(135deg, #32d756 0%, #28a745 100%)';
        }
    };

    return (
        <div
            className={`notification-container ${isVisible ? 'visible' : ''}`}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                display: 'flex',
                justifyContent: 'center',
                zIndex: 9999,
                pointerEvents: 'none',

            }}
        >
            <div
                className="notification-content"
                style={{
                    background: getBackgroundColor(),
                    borderRadius: '16px',
                    padding: '12px 24px',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
                    transform: `translateY(${isVisible ? '0' : '-100px'})`,
                    opacity: isVisible ? 1 : 0,
                    transition: 'transform 0.3s ease, opacity 0.2s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    maxWidth: '370px',
                    width: '100%',
                    pointerEvents: isVisible ? 'auto' : 'none'
                }}
            >
                <span style={{ fontSize: '20px' }}>{getIcon()}</span>
                <span style={{
                    color: 'white',
                    fontSize: '14px',
                    fontWeight: '500',
                    flex: 1,
                    textAlign: 'center',
                    textShadow: '0 1px 2px rgba(0, 0, 0, 0.2)'
                }}>
          {message}
        </span>
                {onClose && (
                    <button
                        onClick={onClose}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            color: 'white',
                            fontSize: '18px',
                            cursor: 'pointer',
                            padding: '0 4px',
                            opacity: 0.8,
                            transition: 'opacity 0.2s'
                        }}
                        onMouseEnter={(e) => e.target.style.opacity = 1}
                        onMouseLeave={(e) => e.target.style.opacity = 0.8}
                    >
                        ✕
                    </button>
                )}
            </div>
        </div>
    );
}

// Хук для использования уведомлений
export function useNotification() {
    const [notification, setNotification] = useState({
        isVisible: false,
        message: '',
        type: 'success'
    });

    const showNotification = (message, type = 'success') => {
        setNotification({
            isVisible: true,
            message,
            type
        });
    };

    const hideNotification = () => {
        setNotification(prev => ({
            ...prev,
            isVisible: false
        }));
    };

    return {
        notification,
        showNotification,
        hideNotification
    };
}